<template>
  <div class="bg">
    <div class="overlay overlay-color">

    </div>
    <div class="login-title">
      DeepDigital Asset Management
    </div>
    <div class="content">
      <div class="middle-block">
        <div  class="top">
          <ul class="languages">
            <li class="language active-language">
              nl
            </li>
            <li class="language">
              en
            </li>
            <li class="language">
              de
            </li>
            <li class="language">
              fr
            </li>
          </ul>
        </div>
        <div class="bottom">
          <div class="logo">
            <!-- <v-icon :large="true" class="logo-icon">gps_fixed</v-icon> -->
            <v-icon :large="true" class="logo-icon">lock_open</v-icon>
          </div>
          <div class="form">
            <v-text-field
              v-model="email"
              browser-autocomplete="email"
              label="Gebruikersnaam"
            ></v-text-field>
            <v-text-field
              v-model="password"
              browser-autocomplete="password"
              label="Wachtwoord"
              type="password"              
            ></v-text-field>
            <div style="margin-bottom:14px; text-align:right;">
              <a href="/reset-password">wachtwoord vergeten</a>
            </div>
            <v-btn :depressed="true" block @click="tryLogin">Login</v-btn>
          </div>
        </div>
      </div>
    </div>
    <notification></notification>
    <!-- <div  class="test">{{showNotification.text}}</div> -->
  </div>
</template>
<script>
import * as types from "../store/types"
import { mapGetters } from 'vuex'
import Notification from "../components/global/Notification"
export default {
   components:{
     Notification
   },
   data() {
     return {email: '',
             password: ""}
   },
   props: {
     source: String
   },
   computed:{
     ...mapGetters({
       showNotification: types.SHOW_NOTIFICATION
     })
   },  
   methods:{
     tryLogin(){
        this.$store.dispatch(types.USER_LOGIN, {email:this.email, password:this.password})
          .then((data) => {
              this.$router.push("/home");      
          })
          .catch( (data) => {
              let message = ''
              if(data == 'AUTHENTICATION_FAILED'){
                message = "Login ongeldig / Account inactief"
              }
              else{
                message = data
              }
              this.$notify(message, {duration:10000, type: 'error'} );
          });
     }
   }
 }
</script>

<style>
.test{
  top:0;
  width:100%;
  background-color: red;
  position: fixed;

}
.bg {
    background: url('../assets/images/bg2.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-color: #ccc;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-direction: row;
}

.overlay {

    top: 0;
    bottom: 0;
    width: 100%;
    position: fixed;
    opacity: .6;
    transition: background-image 2s ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
}

.overlay-color-2{
  background-image: linear-gradient(to bottom right,#002f4b,#dc4225);
}

.overlay-color{
  background-image: linear-gradient(to bottom right,#546E7A,#607D8B);
}

.overlay-color-1{
  background: #10b7a1; /* Old browsers */
  background: -moz-radial-gradient(center, ellipse cover, #10b7a1 0%, #0d9275 61%, #0d9275 100%); /* FF3.6-15 */
  background: -webkit-radial-gradient(center, ellipse cover, #10b7a1 0%,#0d9275 61%,#0d9275 100%); /* Chrome10-25,Safari5.1-6 */
  background: radial-gradient(ellipse at center, #10b7a1 0%,#0d9275 61%,#0d9275 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#10b7a1', endColorstr='#0d9275',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
}

.content{
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.middle-block{
  width: 600px;
  display:flex;
  position: absolute;
  z-index: 9999;
  justify-content: center;
  align-items: center;
  align-content: center;
  display: flex;
  text-align: center;
  opacity: 0.85;

  flex-direction: column;

}

.logo{
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;

}

.logo-icon{
  color: #fff !important;
  font-size: 80px !important;
  margin-bottom: 20px;
  justify-content: center;
  align-items: center;
  align-content: center;
  display: flex;
  margin-right: 50px;
  margin-left: 50px;
  margin-top: 8px;

}

.form{
  width: 100%;
  background-color: #fff;
  padding: 22px 12px;



}

.login-title{
  position: absolute;
  z-index: 9998;
  top: 0;
  left:0;
  padding: 20px 20px;
  font-weight:  100;
  color: #fff;
-webkit-font-smoothing: antialiased;
  font-family: Roboto;
  font-size: 28px !important;

}

.bottom{
  border: solid 8px #fff;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  width: 600px;
  display: flex;
}

.languages{
  display: flex;
  width: 100%;
  justify-content: flex-end;
  list-style-type: none;

}

.language{
  border-right: 1px solid #fff;
  padding-left: 4px;
  padding-right: 4px !important;
  cursor: pointer;
}

.language:hover{
  color: #E91E63;
}

.active-language{
  background-color: #E91E63;
  color: #fff !important;
  border-top-left-radius: 7px !important;

}

.language:last-child{
   border-right: none;
}

.active-language .language:first-child {

}

.top{
  position: relative;
  z-index: 9999;
  color: #fff;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  text-transform: uppercase;
}
</style>
